<template>
  <v-list dense class="manager-nav">
    <v-list-item class="manager-nav__item" link to="/manager" exact>
      <v-list-item-action>
        <v-icon color="primary">mdi-chart-pie</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="subtitle-2">
          {{ $vuetify.lang.t("$vuetify.navigations.dashboard") }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider
      v-if="visibleSections.length"
      class="manager-nav__divider"
    ></v-divider>

    <template v-for="(section, index) in visibleSections">
      <v-list-group
        :key="'group-' + section.key"
        v-model="sectionState[section.key]"
        no-action
        class="manager-nav__group"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="manager-nav__header">
              {{ section.title }}
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in section.items"
          :key="item.key"
          class="manager-nav__item"
          link
          :to="item.to"
          :exact="item.exact || false"
          @click="item.action ? item.action() : null"
        >
          <v-list-item-action>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider
        v-if="index < visibleSections.length - 1"
        :key="'divider-' + section.key"
        class="manager-nav__divider"
      ></v-divider>
    </template>

    <v-divider
      v-if="visibleSections.length"
      class="manager-nav__divider"
    ></v-divider>

    <v-list-item class="manager-nav__item" link @click="logout">
      <v-list-item-action>
        <v-icon color="primary">mdi-logout</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="subtitle-2">
          {{ $vuetify.lang.t("$vuetify.navigations.logout") }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import Auth from "@/helpers/authentication";
export default {
  data: function() {
    return {
      perm: Auth.isAuthenticated()["permission"],
      sectionState: {
        catalog: false,
        finance: false,
        tools: false,
        admin: false,
      },
    };
  },
  computed: {
    isManager() {
      return this.perm == "manager";
    },
    visibleSections() {
      const locale = this.$i18n.locale;
      void locale;

      return [
        {
          key: "catalog",
          title: this.$vuetify.lang.t("$vuetify.navigations.section_catalog"),
          items: [
            {
              key: "companys",
              title: this.$vuetify.lang.t("$vuetify.navigations.companys"),
              icon: "mdi-briefcase",
              to: "/manager/companys",
            },
            {
              key: "products",
              title: this.$vuetify.lang.t("$vuetify.navigations.products"),
              icon: "mdi-cart",
              to: "/manager/products",
            },
            {
              key: "gln_list",
              title: this.$vuetify.lang.t("$vuetify.navigations.gln_list"),
              icon: "mdi-map-marker-radius",
              to: "/manager/glns",
            },
          ],
        },
        {
          key: "finance",
          title: this.$vuetify.lang.t("$vuetify.navigations.section_finance"),
          items: this.isManager
            ? [
                {
                  key: "membership_finances",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.membership_finances"
                  ),
                  icon: "mdi-cash-multiple",
                  to: "/manager/finances/membership",
                },
                {
                  key: "barcode_finances",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.barcode_finances"
                  ),
                  icon: "mdi-cash-multiple",
                  to: "/manager/finances/barcode",
                },
                {
                  key: "gs1_invoices",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.gs1_invoices"
                  ),
                  icon: "mdi-file",
                  to: "/manager/invoices/membership",
                },
                {
                  key: "gs1_solutions_invoices",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.gs1_solutions_invoices"
                  ),
                  icon: "mdi-file",
                  to: "/manager/invoices/barcode",
                },
              ]
            : [],
        },
        {
          key: "tools",
          title: this.$vuetify.lang.t("$vuetify.navigations.section_tools"),
          items: this.isManager
            ? [
                {
                  key: "ai_generator",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.ai_generator"
                  ),
                  icon: "mdi-barcode",
                  action: this.showGenerator,
                },
                {
                  key: "site_admin",
                  title: this.$vuetify.lang.t("$vuetify.navigations.site_admin"),
                  icon: "mdi-web",
                  to: "/manager/site",
                },
                {
                  key: "sent_notifications",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.sent_notifications"
                  ),
                  icon: "mdi-email",
                  to: "/manager/mass/inbox",
                },
              ]
            : [],
        },
        {
          key: "admin",
          title: this.$vuetify.lang.t("$vuetify.navigations.section_admin"),
          items: this.isManager
            ? [
                {
                  key: "users",
                  title: this.$vuetify.lang.t("$vuetify.navigations.users"),
                  icon: "mdi-account",
                  to: "/manager/users",
                },
                {
                  key: "administrators",
                  title: this.$vuetify.lang.t(
                    "$vuetify.navigations.administrators"
                  ),
                  icon: "mdi-account-multiple",
                  to: "/manager/administrators",
                },
              ]
            : [],
        },
      ].filter((section) => section.items.length > 0);
    },
  },
  methods: {
    showGenerator() {
      this.$root.aiGeneratorState = true;
    },
    logout() {
      localStorage.clear();
      return (window.location.href = "/login");
    },
  },
};
</script>

<style scoped>
.manager-nav__header {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.manager-nav__group {
  margin-top: 4px;
}

.manager-nav__item {
  padding-left: 12px !important;
}

.manager-nav__item .v-list-item__action:first-child {
  margin-right: 12px;
  min-width: 28px;
}

.manager-nav__divider {
  margin: 8px 16px;
}
</style>
